<template lang="pug">
include ../pug/svg
div.block(:class="[block.type, block.subtype]" @mouseleave="focus=null")
	hgroup
		contenteditable(tag="h2" :spellcheck="(focus===1)" :class="{fade:focus&&focus!==1}" :contenteditable="editable" v-model="block.content.headed" :noNL="true" @focus="focus=1" @blur="focus=null" @keyup="blockUpdated")
		contenteditable(tag="h3" :spellcheck="(focus===2)" :class="{fade:focus&&focus!==2}" :contenteditable="editable" v-model="block.content.subheaded" :noNL="true" @focus="focus=2" @blur="focus=null" @keyup="blockUpdated")
	contenteditable.p(tag="div" :spellcheck="(focus===3)" :class="{fade:focus&&focus!==3}" :contenteditable="editable" v-model="block.content.onecolumn" :noNL="false" @focus="focus=3" @blur="focus=null" @keyup="blockUpdated")
	div.modal.settings(v-if="block.settings.active" @mouseleave="toggleSettings()")
		ModalBar(label="Block Settings" :useDrag="true" @close="toggleSettings()")
		pre {{block.settings}}
</template>

<script>
import contenteditable from 'vue-contenteditable';
import ModalBar from '../components/ModalBar';

export default {
	name: 'BlockImageOverText',
	props:['block'],
	emits: ['blockUpdated', 'toggleSettings'],
	components: {
		contenteditable,
		ModalBar,
	},
	data() {
		return {
			focus: null,
			editable: true,
		}
	},
	methods: {
		blockUpdated() {
			this.$emit('blockUpdated');
		},
		toggleSettings() {
			this.$emit('toggleSettings', this.block);
		},
	},
}
</script>

<style lang="scss">
.headergroup {}
</style>
